import React, { memo } from 'react';

import NotificationsNavIcon from 'containers/App/Header/Notifications/NotificationsNavIcon';

type TopBarNotificationsProps = {
  id?: string;
};

const TopBarNotifications = memo(function TopBarNotifications({ id }: TopBarNotificationsProps) {
  return <NotificationsNavIcon standalone id={id} />;
});

export default TopBarNotifications;
